<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>自选职业推送管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link to="/users/occupation-questionnaire/create">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">新增自选职业推送
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90" />
        <el-table-column prop="title"
                         label="推送标题"
                         min-width="120" />
        <el-table-column prop="starttime"
                         min-width="180"
                         label="开始时间-结束时间">
          <template slot-scope="scope">{{ scope.row.starttime + ' ~ ' + scope.row.endtime }}</template>
        </el-table-column>
        <el-table-column prop="adminname"
                         label="创建人"
                         min-width="120" />
        <el-table-column prop="status"
                         label="状态">
          <template slot-scope="scope">
            <template v-for="one in statusLabels">
              <span v-if="one.value === scope.row.status">{{one.label}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="350">
          <template slot-scope="scope">
            <div class="button-gutter">
              <el-button size="mini"
                         type="success"
                         v-if="scope.row.status === 1"
                         :disabled="hasPublished"
                         plain
                         @click="onSetStatus(scope.row.id, 2)">发布
              </el-button>
              <el-button size="mini"
                         type="info"
                         v-if="scope.row.status === 2"
                         plain
                         @click="onSetStatus(scope.row.id, 3)">下线
              </el-button>
              <router-link :to="`/users/occupation-questionnaire/update/${scope.row.id}`"
                           v-if="scope.row.status !== 1">
                <el-button size="mini" plain>查看</el-button>
              </router-link>
              <router-link :to="`/users/occupation-questionnaire/update/${scope.row.id}`"
                           v-if="scope.row.status === 1">
                <el-button size="mini"
                           icon="el-icon-edit"
                           type="primary" plain>编辑
                </el-button>
              </router-link>
              <router-link :to="`/users/occupation-questionnaire/preview/${scope.row.id}`">
                <el-button size="mini"
                           type="primary" plain>预览</el-button>
              </router-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../occupation-questionnaire.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        name: null,
      },
      exportHeader: [
        {
          key: 'id',
          text: '自选职业推送ID',
        },
        {
          key: 'name',
          text: '自选职业推送名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
      statusLabels: [
        {label: '新创建', value: 1},
        {label: '发布中', value: 2},
        {label: '已下线', value: 3},
      ],
      hasPublished: false
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getOccupationQuestionnaireTable', params).then((data) => {
        this.hasPublished = data.data.has_published
        return new Promise((resolve) => resolve(data))
      })
    },
    onSetStatus (id, status) {
      this.$confirm('您确认要执行该操作吗？', '警告', {type: 'warning'}).then(() => {
        request.common('setOccupationQuestionnaireStatus', {id, status}).then(() => {
          this.$message.success('操作成功！')
          this.onRefresh()
        })
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/occupation-questionnaire/pages/OccupationQuestionnaireTable.vue